import SEO from "../components/SEO";
import PageBanner from "../components/layout/PageBanner";
import Container from "../components/layout/Container";

const CookiePolicy = () => (
  <main>
    <SEO
      title="Cookie Policy"
      description="Waterfront Cafe cookie policy."
    />

    <PageBanner
      title="Cookie Policy"
      eyebrow="Legal"
      text="How cookies and embedded services may be used on this website."
      image="https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1600&q=80"
    />

    <section className="section legal-page">
      <Container>

        <h2>Cookie Policy</h2>

        <p>Last Updated: June 2026</p>

        <p>This Cookie Policy explains how Waterfront Cafe uses cookies and similar technologies on our website.</p>

        <h2>What Are Cookies?</h2>

        <p>Cookies are small text files stored on your device when you visit a website.</p>

        <p>Cookies help websites function correctly, improve performance, remember preferences, and provide information about visitor interactions.</p>

        <h2>Why We Use Cookies</h2>

        <p>We use cookies to:</p>
        <ul>
          <li>Ensure website functionality.</li>
          <li>Improve website performance.</li>
          <li>Enhance user experience.</li>
          <li>Remember visitor preferences.</li>
          <li>Analyse website traffic.</li>
          <li>Maintain website security.</li>
          <li>Support embedded location and social media services.</li>
        </ul>

        <h2>Types of Cookies We Use</h2>

        <h3>Strictly Necessary Cookies</h3>

        <p>These cookies are essential for website operation and security.</p>
        
        <p>They support:</p>
        <ul>
          <li>Page navigation</li>
          <li>Website security</li>
          <li>Form functionality</li>
          <li>Session management</li>
          <li>Accessibility features</li>
        </ul>

        <p>These cookies cannot be disabled because the website would not function correctly without them.</p>

        <h3>Analytics Cookies</h3>

        <p>Analytics cookies help us understand how visitors use our website.</p>
        
        <p>They may collect information such as:</p>
        <ul>
          <li>Pages visited</li>
          <li>Time spent on pages</li>
          <li>Device type</li>
          <li>Browser information</li>
          <li>Visitor interactions</li>
        </ul>

        <p>This information helps us improve website performance and customer experience.</p>

        <h3>Functional Cookies</h3>

        <p>Functional cookies allow the website to remember preferences and settings.</p>
        
        <p>Examples include:</p>
        <ul>
          <li>Accessibility settings</li>
          <li>User preferences</li>
          <li>Language settings</li>
        </ul>

        <h3>Third-Party Cookies</h3>

        <p>Certain services integrated into the website may place cookies, including:</p>

        <ul>
          <li>Google Maps</li>
          <li>Social media platforms</li>
          <li>Embedded content providers</li>
          <li>Website analytics services</li>
        </ul>

        <p>These third parties may process information in accordance with their own privacy policies.</p>

        <h2>Cookie Consent</h2>

        <p>In accordance with  GDPR and the Privacy and Electronic Communications Regulations (PECR), non-essential cookies are only activated after obtaining your consent.</p>

        <p>Visitors can accept, reject, or customise cookie preferences using the website's cookie banner.</p>

        <h2>Managing Cookies</h2>

        <p>Most browsers allow users to:</p>
        <ul>
          <li>View cookies</li>
          <li>Delete cookies</li>
          <li>Block cookies</li>
          <li>Restrict cookies</li>
        </ul>

        <p>Please note that disabling cookies may affect website functionality.</p>

        <h2>Changes to This Policy</h2>

        <p>We may update this Cookie Policy periodically. Any updates will be published on this page.</p>

      </Container>
    </section>
  </main>
);

export default CookiePolicy;